import { Button } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import { constants } from "../../constants/constants";
import * as dataDescriptionAction from "../../actions/dataDescriptionAction";
import { connect } from "react-redux";
// import DataTable from "./itemTable";
import ConfigEditor from "./itemTable";
import {
  BatchDdNameValuesInsert,
  createNewConfigService,
} from "../../services/DataDescsService";
import "./itemTable.css";

const MergeDDPopup = ({
  injectIntlTranslation,
  intl,
  data = {},
  createNewDataDescription = () => {},
  miscState,
  newConfigGroup = [],
  onSuccess,
  getConfigGroups = () => {},
  setSnackBar,
}) => {
  const [initialOptions, setInitialOptions] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [availableOptions, setAvailableOptions] = useState(initialOptions);

  useEffect(() => {
    const options = Object.keys(data || {}).map((ele) => {
      return { value: ele, label: ele, obj: data[ele] };
    });
    setInitialOptions(options);
  }, [data]);

  useEffect(() => {
    setAvailableOptions(initialOptions);
  }, [initialOptions]);

  useEffect(() => {
    const selectedIds = selectedItems.map((item) => item.value);
    const filteredOptions = initialOptions.filter(
      (option) => !selectedIds.includes(option.value)
    );
    setAvailableOptions(filteredOptions);
  }, [selectedItems]);

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedItems([...selectedItems, formatInitialData(selectedOption)]);
    }
  };

  const handleDelete = (itemToDelete) => {
    setSelectedItems(
      selectedItems.filter((item) => item.name !== itemToDelete.name)
    );
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "500px",
      maxWidth: "400px",
      marginBottom: "10px",
    }),
  };

  const formatInitialData = (item) => {
    const [conTemp = null] = newConfigGroup || [];
    return {
      name: item.obj.Name,
      values: item.obj.Values
        ? item.obj.Values.map((v) => ({
            value: v.Value,
            description: v.Attributes?.Description || "",
            state: v.Attributes?.State,
          }))
        : [],
      configGroup: conTemp?.label || "",
      type: item.obj.Values.length ? "Dropdown" : "Discrete", // Default type
      description: "",
    };
  };

  const transformAccessoryToDropdown = (input, i) => {
    const {
      name = "",
      values = [],
      configGroup,
      type,
      description,
    } = input || {};
    const [configTemp = null] = newConfigGroup.filter(
      (x) => x.label === configGroup
    );
    const output = {
      modelId: miscState?.selectedModel || "", // e.g. "522d0ea7-af85-42b5-8130-d48ccb710dbd"
      ddName: name, // e.g. "sUnit"
      description: description, // e.g. "Unit Size"
      sort: i + 1,
      configGroupId: configTemp ? configTemp?.configGroupId : "", // e.g. "c8638a8f-b368-42b1-b310-c3b6701cc2db"
      columnType: type,
      values: [],
    };

    let sortCounter = 1;

    values.forEach((item) => {
      output.values.push({
        value: item.value,
        description: description || item.value,
        isActive: true,
        sort: sortCounter++,
      });
    });

    return output;
  };

  const createPayload = async () => {
    const BATCH_SIZE = 5;

    let flag = false;
    selectedItems.forEach((ele) => {
      if (ele.configGroup === "" || ele.name === "") {
        flag = true;
      }
    });

    if (flag) {
      setSnackBar(true, "error", "Please fill up all fields.");
      return;
    }

    const chunkArray = (array, size) => {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
      }
      return result;
    };

    const chunks = chunkArray(selectedItems, BATCH_SIZE);

    window.startLoading();

    try {
      for (let i = 0; i < chunks.length; i++) {
        const payload = {
          ddNames: chunks[i].map((x, index) =>
            transformAccessoryToDropdown(x, index)
          ),
        };

        const response = await BatchDdNameValuesInsert(payload);
        console.log(`Batch ${i + 1} response:`, response);
      }
    } catch (err) {
      console.error("Error in batch insert:", err);
    } finally {
      window.stopLoading();
      onSuccess();
    }
  };

  // const createPayload = async () => {
  //   let payload = {
  //     ddNames: selectedItems.map((x, i) => {
  //       return transformAccessoryToDropdown(x, i);
  //     }),
  //   };

  //   window.startLoading();
  //   await BatchDdNameValuesInsert(payload)
  //     .then((res) => {
  //       console.log(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })
  //     .finally(() => {
  //       window.stopLoading();
  //     });
  // };

  const createValue = async (value) => {
    window.startLoading();
    await createNewConfigService({
      modelId: miscState?.selectedModel,
      configGroupName: value,
      sort: newConfigGroup.length + 1,
    })
      .then((res) => {
        console.log(res.data);
        getConfigGroups(miscState?.selectedModel, () => {});
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        window.stopLoading();
      });
  };

  return (
    <div className="searchable-multi-select">
      <h3>Select Items</h3>

      <div style={{ maxWidth: "500px" }}>
        <Select
          options={availableOptions}
          onChange={handleChange}
          styles={customStyles}
          isClearable
          placeholder="Search and select items..."
          value={null}
        />
      </div>

      <div className="selected-items">
        <ConfigEditor
          setData={setSelectedItems}
          handleDelete={handleDelete}
          data={selectedItems}
          modelId={miscState?.selectedModel}
          newConfigGroup={newConfigGroup}
          createValue={createValue}
        />
      </div>

      <div style={{ width: "100%", textAlign: "right" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            createPayload();
          }}
          disabled={false}
          style={{
            marginLeft: "auto",
            marginTop: "20px",
            background:
              "linear-gradient(99.7deg, #15205E -19.43%, #0076F4 80.93%)",
          }}
        >
          {injectIntlTranslation(intl, "merge", constants.merge)}
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataDescriptionState: state.data_description,
  miscState: state.misc,
  fullLangCode: state.locale.message,
});

const mapDispatchToProps = (dispatch) => {
  return {
    createNewDataDescription: async (requestPayload) =>
      dispatch(dataDescriptionAction.createNewDataDescription(requestPayload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MergeDDPopup);
